import React, { useMemo } from 'react';
import clsx from 'clsx';
import styles from './styles.module.css';
/**
 *  Компонент `<Divider />` добавляет вертикальную или горизонтальную линию.
 *  Это позволяет визуально разделять блоки вёрстки.
 * @example ```jsx
 *  <Divider orientation="vertical" />
 * ```
 */
export const Divider = ({
  className = '',
  orientation = 'horizontal',
  variant = 'line',
  ...props
}) => {
  const classNames = useMemo(() => clsx(styles.divider, styles[orientation], styles[variant], className), [className, orientation, variant]);
  return /*#__PURE__*/React.createElement("hr", {
    "aria-orientation": orientation,
    className: classNames,
    ...props
  });
};